import { HoleParam } from "../types/hole";

const WHS_SLOPE_MIN = 55;
const WHS_SLOPE_MAX = 155;

function getCrBounds(holeCount: number): { min: number; max: number } {
  switch (holeCount) {
    case 6:
      return { min: 18, max: 40 };
    case 9:
      return { min: 24, max: 48 };
    case 12:
      return { min: 36, max: 60 };
    case 18:
      return { min: 54, max: 84 };
    default:
      return { min: holeCount * 3, max: holeCount * 5 };
  }
}

function sumPar(holesParams: HoleParam[]): number {
  return holesParams.reduce((sum, hole) => sum + (Number(hole.par) || 0), 0);
}

export function validateCourseRatingForLayout(
  courseRating: number,
  holesParams: HoleParam[] | null | undefined
): string | null {
  if (!holesParams || holesParams.length === 0) {
    return "Scorecard setup incomplete (0 holes)";
  }

  if (isNaN(courseRating)) {
    return "Missing Course Rating";
  }

  const holeCount = holesParams.length;
  const parSum = sumPar(holesParams);

  if (parSum > 0) {
    const maxAbovePar = Math.max(4, Math.ceil(holeCount * 0.75));
    const minBelowPar = 3;

    if (courseRating < parSum - minBelowPar) {
      return "Course Rating too low for layout";
    }
    if (courseRating > parSum + maxAbovePar) {
      return "Course Rating inconsistent with layout";
    }
    return null;
  }

  const { min: minCr, max: maxCr } = getCrBounds(holeCount);

  if (courseRating < minCr || courseRating > maxCr) {
    return "Course Rating inconsistent with hole count";
  }

  return null;
}

export function validateSlopeRating(slope: number): string | null {
  if (isNaN(slope) || slope <= 0) {
    return "Missing Slope Rating";
  }
  if (slope < WHS_SLOPE_MIN || slope > WHS_SLOPE_MAX) {
    return "Invalid Slope Rating";
  }
  return null;
}
